// extracted by mini-css-extract-plugin
module.exports = {"GramSet":"Gram_GramSet__3PsmD","Location":"Gram_Location__2ktqL"};